<!-- PCB下单 右边栏 -->
<template>
  <div class="quote-right">
    <!-- 生产周期 -->
    <Deltime 
      :value="pcbPrice.deltime"
      :options="deltimeOptions" 
      :unsought="pcbPrice.unsought"
      @change="handleDeltimeChange"
    />
    <!-- 发货时间 -->
    <DeliveryTime :tips="(pcbPrice.suggest || {}).timetips" />
    <!-- 价格明细 -->
    <PriceDetails 
      :priceTotal="priceTotal" 
      :board_type="pcbParams.board_type"
      :spray="pcbParams.spray"
      :isFpcNeedAudit="isFpcNeedAudit"
    />
    <div class="quote-right__btns">
      <el-button 
        round 
        class="quote-right__btns__check"
        @click="handleCheckOrder"
      >
        <img 
          class="quote-right__btns__check__icon_new"
          :src="require('@@/assets/img/icons/icon_new2.png')" 
        />
        <img 
          class="quote-right__btns__check__icon"
          :src="require('@@/assets/img/icons/icon_check.png')" 
        />
        检查订单
      </el-button>
      <el-button 
        round 
        type="primary" 
        class="quote-right__btns__submit"
        :loading="submitLoading" 
        @click="handleSubmit"
      >
        提交订单
      </el-button>
    </div>
    <!-- 免责声明 -->
    <Disclaimers v-model="pcbParams.agreen_disclaimers" />

    <!-- 检查订单 -->
    <CheckOrder 
      ref="checkOrderRef" 
      :submitLoading="submitLoading"
      v-on="$listeners"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
// 生产周期
import Deltime from './deltime'
// 发货时间
import DeliveryTime from './deliveryTime'
// 价格明细
import PriceDetails from './priceDetails'
// 免责声明
import Disclaimers from './disclaimers'
// 检查订单
import CheckOrder from '../checkOrder/index'

import { isPcbSite } from '@@/utils/is'
import { sensorsTrack } from '@@/utils/sensors'
import { formatPcbParams, validatePcbQuote, isFpcNeedAudit } from '@@/utils/pcbQuoteFormat'
import { submitPcbQuote, getCustomTagsList } from '@@/api/pcb'
import { removeBefoerLoginPcbParams } from '@@/views/pcbQuote/components/notLogin'

export default {
  components: {
    Deltime,
    DeliveryTime,
    PriceDetails,
    Disclaimers,
    CheckOrder
  },
  // 来源：pcbQuote/index.vue
  inject: {
    pcbParams: { default: {} },
    getPcbPrice: { default: () => ({}) },
    getPriceTotal: { default: () => ({}) },
  },
  computed: {
    // 获取实时的计价数据
    pcbPrice() {
      return this.getPcbPrice()
    },
    priceTotal() {
      return this.getPriceTotal()
    },
    // PCB生产周期选项
    deltimeOptions() {
      const { suggest = {} } = this.pcbPrice
      return suggest.deltime || []
    },
    // FPC 板子层数为 8 10 12 价格以审核为准
    isFpcNeedAudit() {
      return isFpcNeedAudit(this.pcbParams)
    },
  },
  data() {
    return {
      submitLoading: false,
    }
  },
  methods: {
    // 交期改变
    handleDeltimeChange(deltime) {
      const { color, bheight, standard_deltime } = this.deltimeOptions.find(item => item.name == deltime) || {}
      const data = { deltime, color, bheight, standard_deltime }
      this.pcbParams = Object.assign(this.pcbParams, { ...data })
    },

    // PCB校验
    validatePcb() {
      const valids = validatePcbQuote(this.pcbParams)
      if (valids.length > 0) {
        this.$emit('validate', valids)
        return valids
      }
      return []
    },
    // 检查订单
    handleCheckOrder() {
      this.validatePcb()
      this.$refs.checkOrderRef.show()
    },
    // 提交订单
    async handleSubmit() {
      try {
        const valids = this.validatePcb()
        if (valids.length > 0) return false

        if (!this.pcbParams.agreen_disclaimers) {
          this.$topWarning.error({ content: '请先勾选免责声明再提交订单', duration: 3000, closeAll: true })
          return false
        }

        this.submitLoading = true

        if (this.pcbParams.board_type === 'FR-4') {
          // 内标签 确认弹框
          const inner_box_label = await this.confirmInnerBoxLabel(this.pcbParams.inner_box_label)
          this.pcbParams.inner_box_label = inner_box_label
        }

        const data = await this.submitPcbQuote()
        if (data) {
          // 删除缓存参数
          removeBefoerLoginPcbParams()

          const id = data.id
          const boardType = (this.pcbParams || {}).board_type || ''
          sessionStorage.setItem(`orders_${id}`, JSON.stringify({ type: 'PCB', referer: `/quote?board_type=${boardType}`, data, boardType }))
          // PCB站点
          if (isPcbSite) {
            this.$router.push({ 
              path: '/quote_new/success',
              query: { id }
            })
          } else {
            // 用户中心站点
            // 跳转到对应的提交页成功页（共用一个提交页成功页，路由不同）
            const path = this.$route.path.replace('submit', 'success')
            targetSelfWindow({ path, query: { id } })
          }
        }

        this.submitLoading = false
        return false
      } catch (error) {
        this.submitLoading = false
      }
    },
    // 提交PCB订单
    async submitPcbQuote() {
      const params = formatPcbParams(this.pcbParams)

      this.pcbSensorsTrack(params)
      return await submitPcbQuote(params)
        .then(res => {
          if (!res) return false
          const { retCode, retMsg, result, errInfo } = res
          if (retCode === 0) {
            return result
          } else if (retCode === 101075 && errInfo) {
            const { tips, suggest } = errInfo
            this.$confirm(tips, '温馨提示', {
              confirmButtonText: '同意变更',
              cancelButtonText: '不同意',
              lockScroll: false,
              center: true,
              dangerouslyUseHTMLString: true,
              closeOnClickModal: false,
              closeOnPressEscape: true
            }).then(() => {
              this.pcbParams = Object.assign(this.pcbParams, suggest || {})
              this.handleSubmit()
              return false
            }).catch(() => false)
          } else if (retCode === 101077) {
            this.$confirm(retMsg, '温馨提示', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              lockScroll: false,
              center: true,
              dangerouslyUseHTMLString: true,
              closeOnClickModal: false,
              closeOnPressEscape: true
            }).then(() => {
              this.pcbParams = Object.assign(this.pcbParams, result || {})
              this.handleSubmit()
              return false
            }).catch(() => false)
          } else {
            this.$message.error(retMsg || '未知错误，请稍后重试')
            return false
          }
        })
    },
    // 内标签 需要标签 确认弹框
    async confirmInnerBoxLabel(inner_box_label) {
      // PCB产品标签不是 需要标签 时，不做处理
      if (inner_box_label !== 0) return inner_box_label
      // 需要标签
      try {
        const res = await getCustomTagsList()
        const user_inner_box_label = res && res.result && res.result.user_inner_box_label
        // 当后台用户设置无需标签 且 当前选中需要标签时，弹框提示
        if (user_inner_box_label === '2') {
          return new Promise(resolve => {
            this.$confirm('因您之前有无需贴标签需求，此订单“内标签”下单参数为“需要标签”，请您再次确认包装上是否需进行贴标签。', '是否确定无需贴标签', {
              confirmButtonText: '需要标签',
              cancelButtonText: '无需标签',
              lockScroll: false,
              center: true,
              dangerouslyUseHTMLString: true,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              showClose: false,
            })
            .then(() => resolve(0)) // 返回需要标签
            .catch(() => resolve(2)) // 返回无需标签
          })
        } else {
          return inner_box_label
        }
      } catch (error) {
        return inner_box_label
      }
    },
    // PCB/FPC提交订单神策埋点
    pcbSensorsTrack(params) {
      const data = {
        entrance: 'PCB-提交订单',
        ...params
      }
      // 神策数据埋点
      sensorsTrack('addtocart', data)
    },
  }
}
</script>

<style lang="scss" scoped>

$borderRadius: $--border-radius-base2;
$borderColor: #E6E6E6;
$borderColorHover: #d0d0d0;

.quote-right {
  padding: 0 15px;
  border-radius: $--border-radius-base2;
  border: 1px solid $borderColor;
  background-color: #fff;
  &:hover {
    border-color: $borderColorHover;
  }

  .quote-right__btns {
    display: flex;
    margin-top: 8px;
    .quote-right__btns__check {
      position: relative;
      width: 126px;
      font-size: 14px;
      color: #111111;
      border-color: #AAAAAA;
      &:hover, &:focus {
        border-color: #555555;
        background-color: #FBFBFB;
      }
      &:active {
        border-color: #888888;
        background-color: #FDFDFD;
      }
      .quote-right__btns__check__icon {
        display: inline-block;
        margin-right: 2px;
        width: 16px;
        height: 16px;
        vertical-align: bottom;
      }
      .quote-right__btns__check__icon_new {
        position: absolute;
        left: 2px;
        top: -8px;
        display: block;
        width: 30px;
        height: 16px;
      }
    }
    .quote-right__btns__submit {
      flex: 1;
      margin-left: 6px;
      font-size: 14px;
      font-weight: 700;
      color: #FFFFFF;
      border-color: #15A675;
      background-color: #15A675;
      &:hover, &:focus {
        border-color: #14A070;
        background-color: #14A070;
      }
      &:active {
        border-color: #138F64;
        background-color: #138F64;
        box-shadow: 0px 0px 3px 0px #aaaaaa;
      }
    }
  }
}
</style>